import { nextTick } from 'vue';

const uppercaseDirective = {
  bind(el, _, vnode) {
    el.addEventListener('input', (e) => {
      const selectionStart = e.target.selectionStart;
      const upperValue = e.target.value.toUpperCase();
      vnode.componentInstance.$emit('input', upperValue)

      nextTick(() => {
        e.target.setSelectionRange(selectionStart,selectionStart);
      })
    })
  },
}

export { uppercaseDirective }